import { render, staticRenderFns } from "./CompararModelosXML.vue?vue&type=template&id=6bffe307&scoped=true&"
import script from "./CompararModelosXML.vue?vue&type=script&lang=js&"
export * from "./CompararModelosXML.vue?vue&type=script&lang=js&"
import style0 from "./CompararModelosXML.vue?vue&type=style&index=0&id=6bffe307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bffe307",
  null
  
)

export default component.exports